import { getPortalHttp } from '@/utils/http/portalHttp';
import type { SysConfigApi } from './type.d';
export const agentApi = {
  /**
   * 获取系统配置信息
   */
  reqGetSystemConfig: (): Promise<SysConfigApi.Result> => {
    return getPortalHttp().get<SysConfigApi.Result>('agent/new/sys/config');
  },
};
